import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import CustomHeader from '../components/Header'
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import GroupVRNSelect2 from '../containers/comps/GroupVRNSelectContainer2'
import AdvanceTable from '../components/Tables/AdvanceTable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from "../config/axiosConfig";
import { Link } from 'react-router-dom'; // Add this line

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}

const firstDate = new Date();
const currentDate = new Date();
const currentHours = currentDate.getHours();

if (currentHours < 5) { // AM hours
  currentDate.setDate(currentDate.getDate() + 1); // Add one day
}


class ActivityLog extends React.Component {
    constructor(props) {
        super(props);
         
        this.state = {
            UserAccountBranchID:'',
            SearchTypeId: '',
            CardMappingMasterId: '',
            VRNGroupMasterId: '',
            StartTime: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10),
            EndTime: currentDate.toISOString().substring(0, 10),
            //new Date().toISOString().substring(0, 10),
            NoOfRecords:'',
    


            vehiclesOptions: [
                { value: '0', label: 'All Vehicles' },
                { value: '1', label: 'Vehicle(s)' },
                { value: '2', label: 'Vehicles by Group(s)' }
            ],
            entriesOptions: [
                { value: '0', label: '25' },
                { value: '1', label: '50' },
                { value: '2', label: '100' }
            ],
            Activitydata: [],
            Activitycolumns: [
                { "HeaderText": "Section", "MappingColomn": "section" },
                { "HeaderText": "Activity Name", "MappingColomn": "activityName" },
                { "HeaderText": "Type", "MappingColomn": "activityType" },
                { "HeaderText": "Description", "MappingColomn": "activityDescription" },
                { "HeaderText": "Activity By", "MappingColomn": "activityBy" },
                { "HeaderText": "Date", "MappingColomn": "activityDateTime" }
                

            ],
            Option: 1,
            MasterOption : 1,
            Group: 0,
            Vehicle: 0,


        }


        this.changeHandler = this.changeHandler.bind(this)
        this.submitHandler = this.submitHandler.bind(this)

        this.optionChange = this.optionChange.bind(this)
        this.MasteroptionChange = this.MasteroptionChange.bind(this)
        
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
        this.GetReport=this.GetReport.bind(this);
        
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
      }
       
    
    async submitHandler(e){
        debugger
        let token=localStorage.getItem('token');
        let cards = []
        if(this.state.Group != '0')
        {
        this.GetReport();
        }
        else if(this.state.Vehicle != '0')
        {
            this.GetReport();

        }
        else if(this.state.Option == 1)
        {
            this.GetReport();
        }
        else if(this.state.MasterOption == '1')
        {
            this.GetReport();
        }
        else
        {
            this.setState({
                Activitydata:null
              });
            
        }
        
      }


      GetReport(){
        axiosConfig.post("Portal/GetActivitylog",
        {
            UserAccountBranchID:this.props.data.selectedBranchId,
            SearchTypeId:this.state.Option,
            LogTypeId:this.state.MasterOption,
            CardMappingMasterId:this.state.Vehicle,
            VRNGroupMasterId:this.state.Group,
            StartTime:this.state.StartTime,
            EndTime:this.state.EndTime,
            // NoOfRecords:this.state.NoOfRecords,
        }
    )
    .then(Response => {
          this.setState({
            Activitydata:Response.data.userActivityLog
          });
        

    })
    .catch(error => {
        Swal.fire({
            title: error.response.data.errorMessage,
            text: 'Some Error !',
            icon: 'error',
            confirmButtonText: 'Okay'
        })
    })
}

async optionChange(selectedOption) {
            if (selectedOption == 1) {
                await this.setState({ Option: parseInt(selectedOption), Group: 0, Vehicle: 0 })
            }
            else
                await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
        }

        async MasteroptionChange(selectedOption) {
            
                await this.setState({ MasterOption : selectedOption })
          
        }

async vehicleChange(selectedVehicle) {
        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
    }

async groupChange(selectedGroup) {
        await this.setState({ Group: selectedGroup, Vehicle: 0 })

    }

    render() {

        const { SearchTypeId, CardMappingMasterId, VRNGroupMasterId, StartTime, EndTime,NoOfRecords,Activitydata } = this.state;
        return (
            <>
                {/* <CustomHeader>
                </CustomHeader> */}
                <div style={{ textAlign: 'left', marginLeft: '30px' }}>

<Link to="/Administration" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

</div>
                    <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Activity Log</h4>
                                </div>
                                <div className="card-content">
                                    <div className="card-body"></div>

                                    <div>
                                        <Row>
                                        <GroupVRNSelect2
                                                    showFilterText='true'
                                                    showVehiclesInDropDown='yes'
                                                    onMasterOptionChange={this.MasteroptionChange}
                                                    onOptionChange={this.optionChange}
                                                    onGroupChange={this.groupChange}
                                                    onVehicleChange={this.vehicleChange}
                                                   
                                                />
                                        </Row>
                                    </div><br />
                                    {/* <form className="form" onSubmit={this.submitHandler} > */}
                                        <div className="form-body">
                                            <div className="row">


                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date" id="StartTime" name="StartTime" value={this.state.StartTime} onChange={this.changeHandler} className="form-control" 
                                                         max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)}/>
                                                        <label htmlFor="country-floating">From Date</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date"  id="EndTime" name="EndTime" value={this.state.EndTime} onChange={this.changeHandler} className="form-control" 
                                                          max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)}
                                                          min={this.state.StartTime} />
                                                        <label htmlFor="country-floating">To Date</label>
                                                    </div>
                                                </div>
                                                <div className="col-12" style={{ textAlign: 'center' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1" onClick={this.submitHandler} >Generate Report</button>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-12 col-12">
                                                        
                                                    <AdvanceTable data={this.state.Activitydata} columns={this.state.Activitycolumns}>
                                                    </AdvanceTable>
                                                </div>
                                            </div>

                                        </div>
                                    {/* </form> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                </>
        );
    }
}

export default ActivityLog;









